<template>
  <div v-if="hasItems" class="d-flex gap-1 flex-wrap">
    <el-tag
      v-for="tag in tags"
      :key="tag.id"
      size="small"
      :type="type(tag)"
    >
      {{ tag.title }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    tags: Array,
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasItems() {
      return !_.isEmpty(this.tags);
    },
  },

  methods: {
    type({is_system}) {
      return is_system ? '' : 'info';
    },
  },
}
</script>
